import React, { useRef, useState } from 'react';
import { api } from '../scripts/api';
import { Camera, Truck, CheckCircle, AlertTriangle } from 'lucide-react';

export default function DriverPage() {
  const inputRef = useRef(null);
  const [vin, setVin] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');

  const scan = async (file) => {
    setBusy(true); setMsg('');
    try {
      const fd = new FormData();
      fd.append('file', file);
      const { data } = await api.post('/ocr', fd, { headers: { 'Content-Type': 'multipart/form-data' }});
      setVin((data.candidates || [])[0] || '');
    } catch (e) {
      console.error('Driver OCR failed', e);
      setMsg('OCR failed');
    } finally {
      setBusy(false);
    }
  };

  const act = async (endpoint) => {
    if (!vin) { setMsg('No VIN'); return; }
    setBusy(true); setMsg('');
    try {
      const { data } = await api.post(endpoint, { vin });
      setMsg(`Updated: ${data.updated || 0}`);
    } catch (e) {
      console.error('Driver action failed', e);
      setMsg('Action failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container col">
      <div className="splash">
        <div>
          <div className="splash-title">Driver Tools</div>
          <div className="splash-sub">Scan VIN • Update Status</div>

          <div className="scan-grid">
            <button className="scan-tile" onClick={() => inputRef.current?.click()}>
              <div className="scan-tile-top">
                <div className="scan-icon"><Camera size={22} /></div>
                <div className="scan-chev">↗</div>
              </div>
              <div className="scan-title">Scan VIN</div>
              <div className="scan-sub">Use camera</div>
            </button>

            <button className="scan-tile" onClick={() => act('/driver/mark_picked_up')}>
              <div className="scan-tile-top">
                <div className="scan-icon"><Truck size={22} /></div>
                <div className="scan-chev">↗</div>
              </div>
              <div className="scan-title">Mark Picked Up</div>
              <div className="scan-sub">Update status</div>
            </button>

            <button className="scan-tile" onClick={() => act('/driver/mark_delivered')}>
              <div className="scan-tile-top">
                <div className="scan-icon"><CheckCircle size={22} /></div>
                <div className="scan-chev">↗</div>
              </div>
              <div className="scan-title">Mark Delivered</div>
              <div className="scan-sub">Update status</div>
            </button>
          </div>

          <div style={{ marginTop: 20 }}>
            <input className="input" value={vin} onChange={(e) => setVin(e.target.value)} placeholder="VIN or last-8" />
          </div>
        </div>
      </div>

      <input ref={inputRef} type="file" accept="image/*" capture="environment"
             onChange={(e) => e.target.files?.[0] && scan(e.target.files[0])} style={{ display: 'none' }} />

      {busy && <div className="muted">Working…</div>}
      {msg && (
        <div className="row" style={{ marginTop: 10, gap: 8, alignItems: "center" }}>
          <AlertTriangle size={16} />
          <div className="muted">{msg}</div>
        </div>
      )}
    </div>
  );
}